import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-edit',
	templateUrl: './icon-edit.component.svg',
})
export class IconEditComponent {}
